export default {"src":"/_next/static/image/public/images/ic_bookmark_mydoctors.fed171bed1d31f9347e7a815154171aa.svg","height":156,"width":172};